<template>
  <div class="content">
    <div class="card-box">
      <div class="header">
        <span class="title">{{$t("g.condition")}}</span>
      </div>
      <div class="inp-list">
        <div class="item">
          <span class="label">触发时间</span>
          <el-date-picker
                class="inp"
                v-model="formData.valTime"
                size="small"
                type="daterange"
                unlink-panels
                :range-separator="$t('g.to')"
                :start-placeholder="$t('g.start_date')"
                :end-placeholder="$t('g.end_date')"
                :shortcuts="render.shortcuts"
              >
              </el-date-picker>
        </div>
        <div class="item">
          <span class="label">日志级别</span>
          <el-select class="inp" size="small" v-model="formData.valLogLevel" :placeholder="$t('g.choose')">
              <el-option
                v-for="item in render.logLevels"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </div>
        <div class="item">
          <span class="label">触发对象</span>
          <el-input class="inp" size="small" v-model="formData.valTriggerObj" placeholder="请输入触发对象"></el-input>
        </div>
        <div class="item">
          <span class="label">日志内容</span>
          <el-input class="inp" size="small" v-model="formData.valTriggerContent" placeholder="请输入日志内容"></el-input>
        </div>
      </div>
      <div class="btn-ct">
        <el-button @click="func.search" class="search" type="primary" size="small">{{$t('g.search')}}</el-button>
      </div>
    </div>
    <el-alert
        class="el-alert-my"
        type="success">
        <template #title>
          <div class="el-alert-my-txt">
            <span class="tips">提示：</span>
            <span>双击记录查看日志详情</span>
          </div>
        </template>
    </el-alert>
    <div class="card-box data-table">
      <div class="header">
        <span class="title">{{$t("g.unit_num")}}:{{formData.total}}，{{$t("g.per_page")}}:{{formData.pageSize}}</span>
      </div>
      <el-table
            @row-click="func.rowDblClick"
            :data="formData.tableData"
            style="width: 100%">
            <el-table-column
              prop="id"
              label="#"
              width="30">
            </el-table-column>
            <el-table-column
              prop="time"
              label="触发时间"
              width="180">
            </el-table-column>
            <el-table-column
              prop="object"
              width="220"
              label="触发对象">
            </el-table-column>
            <el-table-column
              prop="level"
              width="180"
              label="日志级别">
            </el-table-column>
            <el-table-column
              prop="content"
              min-width="300"
              label="日志内容">
            </el-table-column>
          </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="func.pageChange"
        :page-size="formData.pageSize"
        :total="formData.total">
      </el-pagination>
    </div>
    <el-dialog
      :title="$t('tips')"
      v-model="formData.dialogVisible"
      width="50%">
      <el-form  label-width="80px" :model="formData.curData">
        <div class="el-form-row">
          <el-form-item label="日志级别">
            <el-input v-model="formData.curData.level" disabled></el-input>
          </el-form-item>
          <el-form-item label="触发时间">
            <el-input v-model="formData.curData.time" disabled></el-input>
          </el-form-item>
        </div>
        <el-form-item label="触发对象">
          <el-input v-model="formData.curData.object" disabled></el-input>
        </el-form-item>
        <el-form-item label="日志内容">
            <el-input rows="5" type="textarea" v-model="formData.curData.content" disabled></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="formData.dialogVisible = false">{{$t('g.btn_confirm')}}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { reactive } from 'vue'
export default {
  name: 'LogSystem',
  setup () {
    const tableData = [
      {
        id: 1,
        time: '2021-08-11 12:12:12',
        object: 'GetAlarmImageList',
        level: '异常日志',
        content: '服务端异常!执行命令定义时出错。有关详细信息，请参阅内部异常。服务端异常!执行命令定义时出错。有关详细信息，请参阅内部异常。服务端异常!执行命令定义时出错。有关详细信息，请参阅内部异常。'
      }, {
        id: 2,
        time: '2021-08-11 12:12:12',
        object: 'Settlement/PushMessage',
        level: '操作日志',
        content: '服务端异常!执行命令定义时出错。有关详细信息，请参阅内部异常。'
      }, {
        id: 3,
        time: '2021-08-11 12:12:12',
        object: 'GetAlarmImageList',
        level: '异常日志',
        content: '服务端异常!执行命令定义时出错。有关详细信息，请参阅内部异常。'
      }
    ]
    const shortcuts = [
      {
        text: '最近一周',
        value: () => {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
          return [start, end]
        }
      }, {
        text: '最近一个月',
        value: () => {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
          return [start, end]
        }
      }, {
        text: '最近三个月',
        value: () => {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
          return [start, end]
        }
      }
    ]
    const logLevels = [
      {
        label: '所有日志',
        value: 0
      },
      {
        label: '调试日志',
        value: 1
      },
      {
        label: '操作日志',
        value: 2
      },
      {
        label: '告警日志',
        value: 3
      },
      {
        label: '异常日志',
        value: 4
      }
    ]
    const render = {
      logLevels,
      shortcuts
    }
    const formData = reactive({
      tableData,
      curData: {},
      valTime: '',
      valLogLevel: 0,
      valTriggerObj: '',
      dialogVisible: false,
      curPage: 1,
      pageSize: 10,
      total: 500,
      valTriggerContent: ''
    })
    const func = {
      search () {
        console.log('formData', formData)
      },
      rowDblClick (row, column, e) {
        console.log('rowDblClick', row, column, e)
        formData.curData = row
        formData.dialogVisible = true
      },
      pageChange (val) {
        console.log('page change', val)
        formData.curPage = val
      }
    }
    return {
      func,
      render,
      formData
    }
  }
}
</script>

<style lang="scss" scoped>
.content{
  box-sizing: border-box;
  padding: 1.25rem;
  margin-bottom: 6.25rem;
  >.card-box{
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;
    margin-bottom: 1.25rem;
    .header{
      text-align:left;
      margin-bottom: 1.25rem;
      >.title{
        font-size:1rem;
        font-weight: 500;
      }
    }
    >.btn-ct{
      text-align: right;
      :deep(.el-button--small){
        padding: 0.625rem 2rem;
      }
    }
    .inp-list{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
      >.item{
        width: 49%;
        display: flex;
        align-items: center;
        margin-bottom: 1.25rem;
        .label{
          margin-right: 0.625rem;
          width: 4.375rem;
        }
        :deep(.el-range-editor--small.el-input__inner){
          flex: 1;
        }
        .inp{
          flex: 1;
        }
      }
    }
  }
  >.el-alert-my{
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;
    .el-alert-my-txt{
      font-size: 0.875rem;
      >.tips{
        font-weight: bold;
      }
    }
    :deep(.el-alert__closebtn){
      top: 1.25rem;
      font-size: 1rem;
    }
  }
  >.data-table{
    :deep(.el-table){
      .cell{
        white-space: normal;
        text-overflow: ellipsis;
      }
      .el-table__row{
        cursor: pointer;
      }
    }
  }
  >.pagination{
    text-align: right;
    margin-top: 1.25rem;
  }
  .el-form-row{
    display:flex;
    justify-content: space-between;
    :deep(.el-form-item){
      width: 49%;
    }
  }
}
@media screen and (max-width:800px) {
    .content{
      >.card-box{
        .inp-list{
          >.item{
            width: 100%;
          }
        }
      }
    }
}
</style>
